import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import Footer from './components/Footer';
import { allArticles } from '@/mocks/articles';

const blogImages: Record<string, string> = {
  'guide-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Data%20analyst%20working%20on%20colorful%20ecommerce%20dashboard%20charts%20on%20dual%20monitors%2C%20modern%20bright%20office%20interior%2C%20green%20plants%20and%20natural%20light%2C%20professional%20yet%20relaxed%20atmosphere%2C%20clean%20editorial%20business%20photography&width=800&height=450&seq=blog-card-1&orientation=landscape',
  'guide-debutant-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Young%20woman%20smiling%20while%20learning%20data%20analysis%20on%20laptop%20in%20cozy%20home%20office%2C%20warm%20morning%20sunlight%2C%20books%20and%20coffee%20on%20desk%2C%20approachable%20beginner%20friendly%20atmosphere%2C%20authentic%20lifestyle%20photography&width=800&height=450&seq=blog-card-2&orientation=landscape',
  'hipobuy-spreadsheet-vs-excel': 'https://readdy.ai/api/search-image?query=Split%20screen%20showing%20modern%20colorful%20dashboard%20on%20left%20versus%20traditional%20spreadsheet%20grid%20on%20right%2C%20clean%20desk%20setup%2C%20professional%20comparison%20concept%2C%20bright%20office%20lighting%2C%20editorial%20tech%20photography&width=800&height=450&seq=blog-card-3&orientation=landscape',
  'hipobuy-spreadsheet-vs-notion': 'https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20showing%20minimalist%20productivity%20interface%20versus%20data%20analytics%20dashboard%2C%20modern%20creative%20workspace%2C%20geometric%20decor%2C%20warm%20afternoon%20light%2C%20tech%20comparison%20aesthetic%2C%20clean%20photography&width=800&height=450&seq=blog-card-4&orientation=landscape',
  'hipobuy-spreadsheet-vs-airtable': 'https://readdy.ai/api/search-image?query=Large%20monitor%20showing%20colorful%20product%20database%20interface%20with%20product%20samples%20arranged%20on%20desk%2C%20bright%20contemporary%20office%2C%20technology%20meets%20retail%20concept%2C%20professional%20product%20management%20photography&width=800&height=450&seq=blog-card-5&orientation=landscape',
  'analyser-ventes-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Ecommerce%20manager%20analyzing%20detailed%20revenue%20charts%20and%20sales%20graphs%20on%20big%20screen%2C%20modern%20office%20with%20warm%20lighting%2C%20authentic%20business%20analysis%20moment%2C%20focused%20professional%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=blog-card-6&orientation=landscape',
  'optimisation-produit-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Product%20manager%20examining%20physical%20items%20on%20desk%20while%20viewing%20product%20analytics%20dashboard%20on%20laptop%2C%20industrial%20modern%20office%2C%20warm%20afternoon%20sunlight%2C%20product%20optimization%20concept%2C%20authentic%20business%20scene&width=800&height=450&seq=blog-card-7&orientation=landscape',
  'templates-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Organized%20collection%20of%20colorful%20spreadsheet%20templates%20viewed%20on%20tablet%20and%20laptop%20screens%2C%20modern%20desk%20setup%2C%20template%20library%20concept%2C%20bright%20morning%20workspace%2C%20organized%20productivity%20aesthetic%2C%20professional%20photography&width=800&height=450&seq=blog-card-8&orientation=landscape',
  'securite-donnees-hipobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20glowing%20padlock%20icon%20over%20laptop%20screen%2C%20sophisticated%20dark%20tech%20environment%20with%20subtle%20ambient%20lighting%2C%20data%20protection%20visualization%2C%20professional%20cybersecurity%20aesthetic%2C%20clean%20futuristic%20composition&width=800&height=450&seq=blog-card-9&orientation=landscape',
  'meilleurs-outils-data-ecommerce-2026': 'https://readdy.ai/api/search-image?query=Award%20winning%20data%20analytics%20dashboard%20displayed%20on%20modern%20devices%2C%20golden%20trophy%20on%20clean%20white%20desk%2C%20success%20and%20achievement%20visualization%2C%20bright%20contemporary%20office%2C%20professional%20technology%20award%20photography%2C%20celebratory%20atmosphere&width=800&height=450&seq=blog-card-10&orientation=landscape',
};

export default function Home() {
  return (
    <div className="bg-background-50">
      <HeroSection />

      {/* Category Grid */}
      <CategoryGrid />

      {/* Problem → Solution Section */}
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-3xl mb-12 md:mb-16">
            <p className="text-xs md:text-sm text-accent-600 font-medium uppercase tracking-wider mb-3">Pourquoi Hipobuy Spreadsheet</p>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              Pourquoi la plupart des e-commerçants échouent sans le Hipobuy Spreadsheet
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed">
              Dans le e-commerce moderne, naviguer sans outil d&apos;analyse structuré, c&apos;est piloter un avion sans tableau de bord.
              Le hipobuy spreadsheet centralise toutes vos données pour des décisions éclairées.
            </p>
          </div>

          {/* Comparison table */}
          <div className="overflow-x-auto rounded-2xl border border-background-200/70 bg-background-50">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left p-4 md:p-5 text-foreground-500 font-medium whitespace-nowrap">Fonction</th>
                  <th className="text-left p-4 md:p-5 text-foreground-500 font-medium whitespace-nowrap">Sans Hipobuy Spreadsheet</th>
                  <th className="text-left p-4 md:p-5 text-accent-600 font-semibold whitespace-nowrap">Avec Hipobuy Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Analyse produit', 'Manuelle et lente', 'Automatisée et rapide'],
                  ['Suivi des ventes', 'Désorganisé', 'Structuré et clair'],
                  ['Prise de décision', 'Basée sur l&apos;intuition', 'Data-driven et fiable'],
                  ['Performance globale', 'Incertaine', 'Optimisée en continu'],
                  ['Gain de temps', 'Heures de travail manuel', 'Analyses instantanées'],
                ].map((row, i) => (
                  <tr key={i} className="border-b border-background-200/50 last:border-0 hover:bg-background-50/50 transition-colors">
                    <td className="p-4 md:p-5 text-foreground-800 font-medium whitespace-nowrap">{row[0]}</td>
                    <td className="p-4 md:p-5 text-foreground-500 whitespace-nowrap">{row[1]}</td>
                    <td className="p-4 md:p-5 text-accent-700 font-medium whitespace-nowrap">{row[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="w-full lg:w-[45%]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20ecommerce%20data%20analytics%20dashboard%20displayed%20on%20laptop%20screen%20with%20colorful%20charts%20and%20product%20performance%20graphs%2C%20bright%20airy%20office%20with%20indoor%20plants%20and%20natural%20sunlight%2C%20professional%20workspace%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20warm%20inviting%20atmosphere&width=900&height=700&seq=about-seo-v2&orientation=portrait"
                alt="Hipobuy Spreadsheet - Dashboard d'analyse de données"
                title="Hipobuy Spreadsheet Interface"
                className="w-full rounded-2xl object-cover aspect-[4/3]"
              />
            </div>
            <div className="w-full lg:w-[55%]">
              <p className="text-xs md:text-sm text-accent-600 font-medium uppercase tracking-wider mb-3">À Propos</p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
                Le Hipobuy Spreadsheet révolutionne l&apos;analyse de données e-commerce
              </h2>
              <p className="text-base text-foreground-600 mb-4 leading-relaxed">
                Conçu par des experts du e-commerce, le hipobuy spreadsheet est bien plus qu&apos;un simple tableur.
                C&apos;est un écosystème complet qui transforme vos données brutes en informations exploitables.
                Fini le temps où vous passiez des heures à compiler manuellement vos chiffres de vente.
              </p>
              <p className="text-base text-foreground-600 mb-6 leading-relaxed">
                Avec le hipobuy spreadsheet, bénéficiez d&apos;une vue d&apos;ensemble sur vos performances,
                identifiez vos produits les plus rentables et anticipez les tendances du marché.
                L&apos;outil s&apos;adapte à votre activité, que vous gériez une petite boutique ou un catalogue de plusieurs milliers de références.
              </p>
              <Link
                to={`/article/${allArticles[0].slug}`}
                className="inline-flex items-center gap-2 text-accent-600 font-semibold text-sm hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Lire le guide complet
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-3">
            <div className="max-w-xl">
              <p className="text-xs md:text-sm text-accent-600 font-medium uppercase tracking-wider mb-2">Fonctionnalités</p>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
                Ce que le <span className="text-accent-600">Hipobuy Spreadsheet</span> peut faire pour vous
              </h2>
            </div>
            <Link
              to={`/article/${allArticles[0].slug}`}
              className="inline-flex items-center gap-2 bg-accent-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              En savoir plus
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: 'ri-line-chart-line', title: 'Analyse des ventes', desc: 'Suivez vos performances en temps réel avec des tableaux de bord intuitifs et des métriques clés personnalisables.' },
              { icon: 'ri-store-2-line', title: 'Gestion multi-boutiques', desc: 'Centralisez les données de toutes vos plateformes de vente dans un seul et même outil puissant.' },
              { icon: 'ri-funds-line', title: 'Prédiction de tendances', desc: 'Anticipez les saisons et les pics de demande grâce à des algorithmes prédictifs avancés.' },
              { icon: 'ri-shield-check-line', title: 'Sécurité des données', desc: 'Vos informations commerciales sont protégées avec un chiffrement de niveau bancaire et une conformité RGPD.' },
            ].map((f, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-accent-200/60 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                  <i className={`${f.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">{f.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-4 py-1.5 rounded-full mb-4">Témoignages</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-tight max-w-2xl">
              Ce que disent les utilisateurs du Hipobuy Spreadsheet
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                name: 'Marc Laurent',
                role: 'E-commerçant depuis 2018',
                text: 'Le hipobuy spreadsheet a complètement transformé ma façon de gérer mes données. En un mois, j&apos;ai identifié trois produits qui me faisaient perdre de l&apos;argent et j&apos;ai pu réorienter ma stratégie. Résultat : +23% de marge nette.',
                avatar: 'ML',
                color: 'bg-primary-100 text-primary-600',
              },
              {
                name: 'Sophie Dubois',
                role: 'Responsable e-commerce',
                text: 'Je cherchais depuis longtemps un outil qui centralise toutes mes données de vente sans me prendre des heures de configuration. Le hipobuy spreadsheet fait exactement ça, et en plus il est incroyablement intuitif.',
                avatar: 'SD',
                color: 'bg-accent-100 text-accent-600',
              },
              {
                name: 'Thomas Petit',
                role: 'Consultant retail digital',
                text: 'Je recommande le hipobuy spreadsheet à tous mes clients. La qualité des analyses et la simplicité d&apos;utilisation en font un outil indispensable pour tout e-commerçant sérieux qui veut scaler son activité.',
                avatar: 'TP',
                color: 'bg-secondary-100 text-secondary-600',
              },
            ].map((t, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-sm font-bold`}>
                    {t.avatar}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{t.name}</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">{t.role}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed italic">&ldquo;{t.text}&rdquo;</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Preview - All 10 Articles */}
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-3">
            <div>
              <p className="text-xs md:text-sm text-accent-600 font-medium uppercase tracking-wider mb-2">Blog SEO</p>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">Ressources Hipobuy Spreadsheet</h2>
            </div>
            <Link
              to={`/article/${allArticles[0].slug}`}
              className="inline-flex items-center gap-2 text-foreground-700 font-medium text-sm hover:text-foreground-900 transition-colors whitespace-nowrap"
            >
              Voir tous les articles
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {allArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200/60 transition-all cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={blogImages[article.slug] || blogImages['guide-hipobuy-spreadsheet']}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2.5 py-1 rounded-full">{article.tag}</span>
                  <h3 className="text-base font-semibold text-foreground-900 mt-3 mb-2 leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.intro}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Full-width CTA */}
      <section className="relative h-[420px] md:h-[560px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20elegant%20laptop%20displaying%20ecommerce%20analytics%20dashboard%2C%20indoor%20plants%20and%20warm%20natural%20sunlight%2C%20peaceful%20productive%20atmosphere%2C%20clean%20contemporary%20aesthetic%2C%20Scandinavian%20office%20design%2C%20warm%20inviting%20color%20palette%2C%20professional%20yet%20cozy&width=1600&height=900&seq=cta-full-v2&orientation=landscape"
          alt="Passez à l'action avec Hipobuy Spreadsheet"
          title="Hipobuy Spreadsheet - Agissez maintenant"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/45"></div>
        <div className="relative z-10 text-center px-4 md:px-6 max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight">
            Passez au niveau supérieur avec Hipobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
            Découvrez comment le hipobuy spreadsheet transforme les données en décisions rentables. Ne laissez plus vos chiffres dormir dans des tableurs inexploités.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-primary-500 text-background-50 px-8 py-4 rounded-full font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line text-lg"></i>
            Accéder au système complet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </section>

      {/* Security Section */}
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto text-center">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-4 py-1.5 rounded-full mb-4">Sécurité</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
            Vos données sont en sécurité avec Hipobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto mb-10 leading-relaxed">
            Aucune collecte de données sensibles, utilisation sécurisée des spreadsheets, transparence totale et conformité aux bonnes pratiques du RGPD.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 text-left">
            {[
              { icon: 'ri-lock-line', title: 'Chiffrement avancé', desc: 'Protection de niveau bancaire pour toutes vos données commerciales.' },
              { icon: 'ri-eye-off-line', title: 'Aucune collecte abusive', desc: 'Seules les données nécessaires au service sont traitées.' },
              { icon: 'ri-file-shield-line', title: 'Conformité RGPD', desc: 'Respect strict des normes européennes de protection des données.' },
              { icon: 'ri-user-settings-line', title: 'Contrôle total', desc: 'Vous gardez la maîtrise complète de vos informations.' },
            ].map((item, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-5 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA with both buttons */}
      <section className="py-10 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-8 py-4 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Hipobuy Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 border-2 border-foreground-300 text-foreground-800 px-8 py-4 rounded-full font-semibold text-sm hover:border-foreground-500 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>
      </section>

      <Footer />

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Hipobuy Spreadsheet",
            "url": import.meta.env.VITE_SITE_URL + "/",
            "description": "Outil d'analyse de données e-commerce - Hipobuy Spreadsheet",
            "sameAs": ["https://kaspreadsheet.com/"]
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Hipobuy Spreadsheet",
            "url": import.meta.env.VITE_SITE_URL + "/",
            "description": "Outil d'analyse de données e-commerce - Hipobuy Spreadsheet",
            "potentialAction": {
              "@type": "SearchAction",
              "target": import.meta.env.VITE_SITE_URL + "/?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />
    </div>
  );
}